import React, {Component} from 'react';
import {useFormikContext} from 'formik';

import AppButton from '../app-button';

interface SubmitButtonProps extends React.HTMLProps<HTMLButtonElement> {
  title: string;
  variant?: string;
  customComponent?: any;
  disabled?: boolean;
  onClickFunction?(): void;
}

function SubmitButton({
  title,
  variant,
  customComponent,
  children,
  disabled,
  onClickFunction,
  ...rest
}: SubmitButtonProps) {
  const {handleSubmit} = useFormikContext();

  if (customComponent) {
    const props = {
      onClick: handleSubmit,
      ...rest,
    };
  }

  return customComponent ? (
    <div
      onClick={() => {
        if (onClickFunction) onClickFunction();
        handleSubmit();
      }}>
      {customComponent}
    </div>
  ) : (
    <AppButton
      variant={variant}
      onClick={() => {
        if (onClickFunction) onClickFunction();
        handleSubmit();
      }}
      type="submit"
      disabled={disabled}
      {...rest}>
      {children ? children : title}
    </AppButton>
  );
}

export default SubmitButton;
